import Component from './Edition';

export default Component;
